import { Box, Grid } from "@mui/material";
import {
	EmailFieldRHF,
	EnhancedDropDownRHFWithLabel,
	ITest,
	LabelPosition,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

interface ISpecialEarningsInfoFieldsPanel extends ITest {
	accountSettingsDDL: any;
}

export const SpecialEarningsInfoFieldsPanel: FC<
	ISpecialEarningsInfoFieldsPanel
> = ({
	accountSettingsDDL
}) => {

		return (
			<>
				<EnhancedDropDownRHFWithLabel
					label="ABC"
					selectName="abc"
					testId="abc"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>
				<EnhancedDropDownRHFWithLabel
					label="Earnings Hours"
					selectName="earningsHours"
					testId="earnings-hours"
					labelPosition={LabelPosition.Top}
					items={accountSettingsDDL ?? []}
					labelColumns={4}
					fieldColumns={8}
					showEmpty
				/>
			</>
		);
	};
